import breadCrumbJson from '../../data/breadCrumbData/breadCrumbObject.json';
export async function getBreadcrumbsBySlug(slug) {
  return (await breadCrumbJson[slug]) ? breadCrumbJson[slug] : [];
}